import { MessagePopup } from "@/components/popups/popup.message"
import { useState } from "react"

interface ComingSoonModalProps {
  message: string
  children?: React.ReactNode
}

export const useComingSoonModal = () => {
  const [isOpen, setIsOpen] = useState(false)

  const openModal = () => {
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const ComingSoonModal = ({ message, children }: ComingSoonModalProps) => {
    return (
      <MessagePopup
        isOpen={isOpen}
        close={closeModal}
        title="Coming soon!"
        message={message}>
        {children}
      </MessagePopup>
    )
  }

  return {
    openModal,
    ComingSoonModal,
  }
}
